module.exports = __webpack_public_path__ + "img/walk.a3a36602.svg";